<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/jj0G5f/images/9781439650004.jpg?1684514755544" alt="This image is the cover for the book Southern Arizona Cemeteries, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Southern Arizona Cemeteries, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>In a quest to understand an area as diverse as Arizona, there can be no better way than to take a journey to the grave sites of its pioneers and observe the style whereby they made their journey from this world. The sites may be as simple as a cross or a shrine by the side of a road or as large as Tucson�s Evergreen Cemetery, which has provided a final resting place to more than 40,000 interments. In this book, one will find the graves of governors, sheriffs, gunfighters, business owners, soldiers, schoolteachers, sports figures, madams, miners, and many others from all walks of life. Where possible, an image of the deceased and a brief bio has been included. The epitaphs, symbols, and expressions of grief on the graves provide an insight into the loss felt by family and friends. The graves are brief glimpses into Arizona�s pioneer past.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jane Eppinga
      </h2>
      
      <p class="authorDescription body article">Jane Eppinga�s writing has received numerous awards. In 1999, she received the Arizona Press Women Communicator of Achievement Award. With more than 300 articles published, her material has appeared in Biology Digest, Arizona Sheriff magazine, Persimmon Hill, Arizona Capitol Times, Tucson Weekly, Good Housekeeping, Arizona Highways, American History, Arizona Daily Star, the Writer, and the Chicken Soup series. Her book Henry Ossian Flipper: West Point�s First Black Graduate was presented to Pres. Bill Clinton on the successful appeal to have Flipper posthumously pardoned. She has done several books for Arcadia�s Images of America and Postcard History series.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?760caeac